import * as amplitude from '@amplitude/analytics-browser';
import { App } from 'App';
import { AppProviders } from 'AppProviders';
import React from 'react';
import ReactDOM from 'react-dom';

amplitude.init(`${process.env.REACT_APP_AMPLITUDE_KEY}`);

ReactDOM.render(
    <React.StrictMode>
        <AppProviders>
            <App />
        </AppProviders>
    </React.StrictMode>,
    document.getElementById('root')
);
